// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CopilotLoader_wrapper__xCk8e"};